module.exports = __webpack_public_path__ + "static/media/about.11a7898.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about.mp4
// module id = yM9c
// module chunks = 3